'use strict';

const processInclude = require('base/util');

jQuery(() => {
    processInclude(require('./newItem/newItem'));
});
